/*
 * ih.googlelogin
 *
 * Stores functions for working with facebook login authentication
 *
 * Depends:
 *      ih 
 *
 */
//    console.log("authenticatedUser", ih.authenticatedUser);   

    ih = ih || {}; 
    ih.googlelogin = ih.googlelogin || {}; 
    
    ih.googlelogin.rerequestNeeded = false;
    ih.googlelogin.callback = false;
    ih.googlelogin.callbackData = false;

    
    ih.googlelogin.login = function()
    {
        document.getElementById("googleSigninDiv").click(); // Click on the checkbox
    }
    
    ih.googlelogin.handleLoginSuccess = function(user)
    {
        ih.googlelogin.rerequestNeeded = false;
        
        ih.googlelogin.callback(user, ih.googlelogin.callbackData);
    }
    
    ih.googlelogin.handleLoginError = function( error_type )
    {
        ih.error("We're sorry, there was a problem receiving permission from Google. Please try again, and be sure to grant access to your email address. Thank you!");
        ih.googlelogin.rerequestNeeded = true;
    }
    
